var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('loading',{attrs:{"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}}),_c('Alert'),_c('BaseFullModal',{attrs:{"dialogConfig":_vm.dialogConfig}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }